import { Component, OnInit } from '@angular/core';
import { Emisor } from '../emisor';
import { EmisorService } from '../emisor.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AlertService } from 'ngx-alerts';


@Component({
  selector: 'app-emisor',
  templateUrl: './emisor.component.html',
  styleUrls: ['./emisor.component.scss']
})
export class EmisorComponent implements OnInit {
  emisor: Emisor[];  
  editForm: FormGroup;

  entidad: Emisor;
  listaEntidad: Emisor[]=[];  
  constructor(private api: EmisorService,private formBuilder: FormBuilder,
    private alertService: AlertService
    ) { }

  ngOnInit() {

    this.api.getEmisor(localStorage.getItem('id')).subscribe(( data: Emisor[])=>{
      console.log(data);
      data.forEach(item => {
        console.log("Holaaa"+item.direccionMatriz);
        this.editForm.controls['codigo'].setValue(item.codigo);
        this.editForm.controls['razonsocial'].setValue(item.razonsocial);
        this.editForm.controls['ruc'].setValue(item.ruc);
        this.editForm.controls['nomcomercial'].setValue(item.nomcomercial);
     
        this.editForm.controls['direccionMatriz'].setValue(item.direccionMatriz);
        this.editForm.controls['codestablecimiento'].setValue(item.codestablecimiento);
        this.editForm.controls['codpintoemision'].setValue(item.codpintoemision);
        this.editForm.controls['contribuyenteespecial'].setValue(item.contribuyenteespecial);
        this.editForm.controls['logoimagen'].setValue(item.logoimagen);
        this.editForm.controls['llevacontabilidad'].setValue(item.llevacontabilidad);
        this.editForm.controls['token'].setValue(item.token);
      });
      
    });

    this.editForm = this.formBuilder.group({
      codigo: [0, Validators.required],
      razonsocial: ['', Validators.required],
      ruc: ['', Validators.required],
      nomcomercial: ['', Validators.required],
      direstablecimiento: ['', Validators.required],
      codestablecimiento: ['', Validators.required],
          llevacontabilidad: ['', Validators.required],
      codpintoemision: ['', Validators.required],
      contribuyenteespecial: ['', Validators.required],
      logoimagen: ['', Validators.required],
      direccionMatriz: ['', Validators.required],
      token: ['', Validators.required]
   });

   

  }

  

  actulizar(){

    this.entidad= new Emisor();
    this.entidad.codigo=this.editForm.controls['codigo'].value;
    this.entidad.razonsocial=this.editForm.controls['razonsocial'].value;
    this.entidad.ruc=this.editForm.controls['ruc'].value;
    this.entidad.nomcomercial=this.editForm.controls['nomcomercial'].value;
    this.entidad.direstablecimiento=this.editForm.controls['direstablecimiento'].value;
    this.entidad.codestablecimiento=this.editForm.controls['codestablecimiento'].value;
    this.entidad.llevacontabilidad=this.editForm.controls['llevacontabilidad'].value;
    this.entidad.codpintoemision=this.editForm.controls['codpintoemision'].value;
    this.entidad.contribuyenteespecial=this.editForm.controls['contribuyenteespecial'].value;
    this.entidad.logoimagen=this.editForm.controls['logoimagen'].value;
    this.entidad.direccionMatriz=this.editForm.controls['direccionMatriz'].value;
    this.entidad.token=this.editForm.controls['token'].value;
    this.listaEntidad[0]=this.entidad;
    this.api.setActulizarCliente(this.listaEntidad).subscribe(

      data  => {
        this.alertService.success("Se actualizo con exito..")
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );
 
  }
      


}
